<div class="flex items-center justify-center min-h-screen overflow-hidden">
    <div class="flex flex-col items-center justify-center">
        <div
            style="
                border-radius: 56px;
                padding: 0.3rem;
                background: linear-gradient(
                    180deg,
                    color-mix(in srgb, var(--p-primary-color), transparent 60%) 10%,
                    var(--surface-ground) 30%
                );
            "
        >
            <div class="w-full bg-surface-0 dark:bg-surface-900 py-5 px-8 sm:px-20 flex flex-col items-center" style="border-radius: 53px">
                <img [src]="logoPath" alt="logo" class="m-auto my-3" width="150" />
                <span class="text-primary font-bold text-3xl">401</span>
                <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2">Not Authorized</h1>
                <div class="text-surface-600 dark:text-surface-200 mb-8">Please sign in to access this page.</div>
                <a href="{{ mainDashboard }}" class="text-color-primary font-bold">Go to {{ companyName }}</a>
            </div>
        </div>
    </div>
</div>
